import { render, staticRenderFns } from "./ContractedWorksSection.vue?vue&type=template&id=31f133f0&"
import script from "./ContractedWorksSection.vue?vue&type=script&lang=js&"
export * from "./ContractedWorksSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports